import React, { ChangeEventHandler } from 'react'
import styled from 'styled-components'

const StyledToggleBtn = styled.div`
  &.cb-toggles-btn label {
    width: 100px !important;
    span {
      width: 100px !important;
    }
  }
  &.cb-toggles-btn label:first-of-type input[type='radio']:focus + span:not(.cb-glyph) {
    border-left: 2px solid #1e1e1e !important;
  }
  &.cb-toggles-btn label:last-of-type input[type='radio']:focus + span:not(.cb-glyph) {
    border-right: 2px solid #1e1e1e !important;
  }
  &.cb-toggles-btn label input[type='radio']:focus + span:not(.cb-glyph) {
    border: 2px solid #1e1e1e !important;
  }
`
interface ToggleButtonProps {
  selectedText: string
  name: string
  buttonOneSelection: string
  buttonTwoSelection: string
  onChange: Function
}

export const ToggleButton: React.FC<ToggleButtonProps> = (props) => {
  const { selectedText, name, buttonOneSelection, buttonTwoSelection, onChange } = props

  return (
    <StyledToggleBtn className="cb-toggles-btn">
      <label>
        <input
          className="button-one"
          onChange={() => onChange(buttonOneSelection)}
          type="radio"
          name={name}
          checked={selectedText === buttonOneSelection}
        />
        <span className="button-one cb-font-size-regular">{buttonOneSelection}</span>
      </label>
      <label>
        <input
          className="button-two"
          onChange={() => onChange(buttonTwoSelection)}
          type="radio"
          name={name}
          checked={selectedText === buttonTwoSelection}
        />
        <span className="button-two cb-font-size-regular">{buttonTwoSelection}</span>
      </label>
    </StyledToggleBtn>
  )
}
